export default __webpack_public_path__ + "static/media/89.43e7ed85.png";